import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import './tutorial-card-info-desktop.scss';
import AppStore from '@assets/images/app-store.webp';
import PlayStore from '@assets/images/play-store.webp';
import AppGallery from '@assets/images/app-gallery.webp';
import TutorialImage from '@assets/images/tutorial-desktop.webp';
import CheckIcon from '@assets/icons/check-icon-min.svg';
import { openAppGallery, openAppStore, openPlayStore } from '../../../utils/utils';
import { useEffect, useState } from 'react';
import dataLayerService from '../../../services/data-layer-service';
const TutorialCardInfoDesktop = () => {
    const pathname = location.pathname;
    const [isTutorial, setIsTutorial] = useState(false);
    const [imageLoaded, setImageLoaded] = useState(false);
    useEffect(() => {
        setIsTutorial(pathname.toLowerCase().includes('tutorial'));
    }, []);
    const handleOpenPlaystore = () => {
        handleDataLayer(!isTutorial ? 'Final_Descarga_Android' : 'Paso0_Cliente_Android', 'Google Play', 'Boton');
        openPlayStore();
    };
    const handleOpenAppstore = () => {
        handleDataLayer(!isTutorial ? 'Final_Descarga_iOS' : 'Paso0_Cliente_iOS', 'App Store', 'Boton');
        openAppStore();
    };
    const handleOpenAppGallery = () => {
        handleDataLayer(!isTutorial ? 'Final_Descarga_Huawei' : 'Paso0_Cliente_Huawei', 'App Gallery', 'Boton');
        openAppGallery();
    };
    const handleDataLayer = (eventName, valor, elemento) => {
        dataLayerService.sendEvent(eventName, {
            Seccion: '',
            SubSeccion: '',
            SubZona: 'Cliente',
            TipoElemento: elemento,
            TipoEvento: 'Click',
            TipoZona: 'Onboarding Digital',
            Valor: valor,
            Zona: 'Paso 0'
        });
    };
    const handleImageLoad = () => {
        setImageLoaded(true);
    };
    return (_jsxs(Box, { className: 'container-tutorial-card-info-desktop', children: [_jsx(Box, { className: "tutorial-card-info-desktop", children: _jsxs(Box, { className: "tutorial-card-info-desktop_info", children: [_jsxs(Box, { className: "tutorial-card-info-desktop_info_title", children: ["Descarga la app\u00A0 ", _jsx("span", { children: "Mibanco" })] }), _jsxs(Box, { className: "tutorial-card-info-desktop_info_icons", children: [_jsx("img", { src: PlayStore, onClick: handleOpenPlaystore, alt: "play-store-image" }), _jsx("img", { src: AppStore, onClick: handleOpenAppstore, alt: "app-store-image" }), _jsx("img", { src: AppGallery, onClick: handleOpenAppGallery, alt: "app-gallery-image" })] }), _jsxs(Box, { className: "tutorial-card-info-desktop_info_features", children: [_jsxs(Box, { className: "tutorial-card-info-desktop_info_features_item", children: [_jsx("img", { src: CheckIcon, alt: "check-icon-min" }), _jsx("span", { children: "Operaciones al instante" })] }), _jsxs(Box, { className: "tutorial-card-info-desktop_info_features_item", children: [_jsx("img", { src: CheckIcon, alt: "check-icon-min" }), _jsx("span", { children: "Transferencias ilimitadas" })] }), _jsxs(Box, { className: "tutorial-card-info-desktop_info_features_item", children: [_jsx("img", { src: CheckIcon, alt: "check-icon-min" }), _jsx("span", { children: "Pr\u00E9stamos al toque" })] }), _jsxs(Box, { className: "tutorial-card-info-desktop_info_features_item", children: [_jsx("img", { src: CheckIcon, alt: "check-icon-min" }), _jsx("span", { children: "Atenci\u00F3n 24/7" })] })] })] }) }), _jsx("div", { children: _jsx("img", { className: 'tutorial-card-info-desktop_image', src: TutorialImage, alt: "", onLoad: handleImageLoad, style: { display: 'block' } }) })] }));
};
export default TutorialCardInfoDesktop;
